import get from 'lodash/get';
import React from 'react';
import PropTypes from 'prop-types';
import './ShoppingCartTooltipContent.custom.scss';

export const SHOPPING_TOOLTIP_NOT_AVAILABLE = 'Please contact supplier';
export default function ShoppingCartTooltipContent({ details, className }) {
  const getValue = (field) => get(details, field, SHOPPING_TOOLTIP_NOT_AVAILABLE);
  const bestPrice = getValue('bestPrice');
  const bestPriceString = parseInt(bestPrice, 10) > 0 ? `${bestPrice} USD/g` : bestPrice;
  return (
    <div className="shopping-cart-tooltip__content">
      <div className={className}>
        Shipping time:<span className={`${className}--value`}>&nbsp;{`${getValue('shippingTime')}`}</span>
      </div>
      <div className={className}>
        Best price:<span className={`${className}--value`}>&nbsp;{bestPriceString}</span>
      </div>
      <div className={className}>
        Largest available package size:<span className={`${className}--value`}>&nbsp;{`${getValue('maxPackSize')}`}</span>
      </div>
    </div>
  );
}

ShoppingCartTooltipContent.defaultProps = {
  className: 'shopping-cart-tooltip--rcs-info',
};

ShoppingCartTooltipContent.propTypes = {
  details: PropTypes.object.isRequired,
  className: PropTypes.string,
};
